'use client';

import { Box } from '@chakra-ui/react';
import React, { memo } from 'react';
import HeaderMobile from './header.mobile';
import { useTelegramBackButton } from '@/_hooks/useTelegramBackButton';

const Header = () => {
  useTelegramBackButton({});

  return <Box
    py={2}
    bg='background.card'
    color='text'
  >
    <Box pt='var(--tg-content-safe-area-inset-top)'>
      <HeaderMobile />
    </Box>
  </Box>
};

export default memo(Header);
